import { Box, Text } from '@moonpig/launchpad-components'
import { system as s } from '@moonpig/launchpad-system'
import { styled } from '@moonpig/launchpad-utils'

const MESSAGE_BUBBLE_WIDTH = 'calc(100% - 42px)'

export const UserMessageStyledBox = styled(Box)`
  ${s({
    bgcolor: 'colorBackground05',
    p: 6,
    mb: 6,
    mr: 0,
    borderRadius: 'borderRadius02',
  })}

  border-bottom-right-radius: 0;
  width: fit-content;
  max-width: ${MESSAGE_BUBBLE_WIDTH};
  margin-left: auto;
  margin-right: 0;
`

export const UserMessageText = styled(Text)`
  ${s({
    typography: 'typeBodyText',
    color: 'colorTextHeadline',
    marginBottom: 0,
  })}
`
